<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/customer/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('kehubianma')">
            <el-input v-model="yt.conditions.code"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehumingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('kehuleixing')">
            <yi_dictionary_select :type="'CUSTOMER_TYPE'" :ids.sync="yt.conditions.type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear()">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1', beforeAdd);
            setAddEnable();
          "
          type="primary"
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <!-- <template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
				</el-button>
			</template> -->
      <!-- 自定义某个字段 -->
       <template #shengshiqu="scope">
        <div v-if="scope.row.cityAdcode">
          <yi_data_select disabled :multiple="false" type="pcd" :ids.sync="scope.row.cityAdcode"> </yi_data_select>
        </div>
       </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="showKezhiDialog(scope.row)">{{ $t('kezhihuacaidan') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('kehuleixingbiangeng', scope.row, 'w1', beforeShowLeiXingDialog)">
              {{ $t('kehuleixingbiangeng') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('shujuxieyimuban', scope.row, '70%')">
              {{ $t('shujuxieyimuban') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xuqixinxi', scope.row, '70%')">
              {{ $t('xuqixinxi') }}
            </el-button>
          </el-col>
          <!-- <el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/customer/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col> -->
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('kehubianma')" required>
              <el-input v-model="yt.editObj.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kehumingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kehujiancheng')">
              <el-input v-model="yt.editObj.shortName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kehuleixing')" required>
              <yi_dictionary_select :type="'CUSTOMER_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required>
              <el-select v-model="yt.editObj.enable">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lianxidizhi')">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="yt.editObj.contactAddress" maxlength="400" show-word-limit> </el-input>
            </el-form-item>
            <el-form-item :label="$t('shiqu')" required>
              <yi_dictionary_select :type="'TIME_ZONE'" :ids.sync="yt.editObj.timeZone"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('nianduyingshou')" required>
              <yi_dictionary_select :type="'CUSTOMER_INFO_ANNUAL_REVENUE'" :ids.sync="yt.editObj.annualRevenue"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('diyu')">
              <yi_dictionary_select :type="'CUSTOMER_INFO_REGION'" :ids.sync="yt.editObj.region"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('hangye')">
              <yi_dictionary_select :type="'CUSTOMER_INFO_INDUSTRY'" :ids.sync="yt.editObj.industry"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jitaiguimo')">
              <yi_dictionary_select type="CUSTOMER_INFO_MACHINE_SCALE" :ids.sync="yt.editObj.scale"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('kehudengji')">
              <yi_dictionary_select type="CUSTOMER_INFO_LEVEL" :ids.sync="yt.editObj.level"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('xiangmuzongjian')">
              <el-input v-model="yt.editObj.projectDirector"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xiangmujingli')">
              <el-input v-model="yt.editObj.projectManager"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jishuzhichi')">
              <el-input v-model="yt.editObj.technicalSupport"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shouqian')">
              <el-input v-model="yt.editObj.presales"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xiaoshou')">
              <el-input v-model="yt.editObj.sales"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shengshiqu')">
              <yi_data_select :multiple="false" type="pcd" :ids.sync="yt.editObj.cityAdcode"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('banshichu')">
              <el-input v-model="yt.editObj.offices"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yewuyuan')">
              <el-input v-model="yt.editObj.salesman"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jitaileixing')">
              <yi_dictionary_select type="CUSTOMER_INFO_MACHINE_TYPE" :ids.sync="yt.editObj.machineType"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('zhengcejiqudao')">
              <el-input v-model="yt.editObj.policiesChannels"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shangjichuangjianshijian')">
              <yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime" :time.sync="yt.editObj.nicheCreateTime"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jingdu')">
              <el-input v-model="yt.editObj.longitude"></el-input>
            </el-form-item>
            <el-form-item :label="$t('latitude')">
              <el-input v-model="yt.editObj.latitude"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shixiaoshijian')">
              <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.endTime"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('yanshoushijian')">
              <yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime" :time.sync="yt.editObj.acceptanceTime"> </yi_time_input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/customer/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item class="noborder" :label="$t('kehubianma')" required>
              <el-input disabled v-model="yt.editObj.code"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kehumingcheng')" required>
              <el-input v-model="yt.editObj.name"></el-input>
            </el-form-item>
            <el-form-item :label="$t('kehujiancheng')">
              <el-input v-model="yt.editObj.shortName"></el-input>
            </el-form-item>
            <el-form-item class="noborder" :label="$t('kehuleixing')" required>
              <yi_dictionary_select disabled :type="'CUSTOMER_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required>
              <el-select v-model="yt.editObj.enable">
                <el-option :label="$t('shi')" :value="true"></el-option>
                <el-option :label="$t('fou')" :value="false"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('lianxidizhi')">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="yt.editObj.contactAddress" maxlength="400" show-word-limit> </el-input>
            </el-form-item>
            <el-form-item :label="$t('shiqu')" required>
              <yi_dictionary_select :type="'TIME_ZONE'" :ids.sync="yt.editObj.timeZone"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('nianduyingshou')" required>
              <yi_dictionary_select :type="'CUSTOMER_INFO_ANNUAL_REVENUE'" :ids.sync="yt.editObj.annualRevenue"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('diyu')">
              <yi_dictionary_select :type="'CUSTOMER_INFO_REGION'" :ids.sync="yt.editObj.region"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('hangye')">
              <yi_dictionary_select :type="'CUSTOMER_INFO_INDUSTRY'" :ids.sync="yt.editObj.industry"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jitaiguimo')">
              <yi_dictionary_select type="CUSTOMER_INFO_MACHINE_SCALE" :ids.sync="yt.editObj.scale"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('kehudengji')">
              <yi_dictionary_select type="CUSTOMER_INFO_LEVEL" :ids.sync="yt.editObj.level"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('xiangmuzongjian')">
              <el-input v-model="yt.editObj.projectDirector"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xiangmujingli')">
              <el-input v-model="yt.editObj.projectManager"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jishuzhichi')">
              <el-input v-model="yt.editObj.technicalSupport"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shouqian')">
              <el-input v-model="yt.editObj.presales"></el-input>
            </el-form-item>
            <el-form-item :label="$t('xiaoshou')">
              <el-input v-model="yt.editObj.sales"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shengshiqu')">
              <yi_data_select :multiple="false" type="pcd" :ids.sync="yt.editObj.cityAdcode"> </yi_data_select>
            </el-form-item>
            <el-form-item :label="$t('banshichu')">
              <el-input v-model="yt.editObj.offices"></el-input>
            </el-form-item>
            <el-form-item :label="$t('yewuyuan')">
              <el-input v-model="yt.editObj.salesman"></el-input>
            </el-form-item>
            <el-form-item :label="$t('jitaileixing')">
              <yi_dictionary_select type="CUSTOMER_INFO_MACHINE_TYPE" :ids.sync="yt.editObj.machineType"> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('zhengcejiqudao')">
              <el-input v-model="yt.editObj.policiesChannels"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shangjichuangjianshijian')">
              <yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime" :time.sync="yt.editObj.nicheCreateTime"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('jingdu')">
              <el-input v-model="yt.editObj.longitude"></el-input>
            </el-form-item>
            <el-form-item :label="$t('latitude')">
              <el-input v-model="yt.editObj.latitude"></el-input>
            </el-form-item>
            <el-form-item :label="$t('shixiaoshijian')">
              <yi_time_input format="yyyy-MM-dd" type="date" :time.sync="yt.editObj.endTime"> </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('yanshoushijian')">
              <yi_time_input format="yyyy-MM-dd HH:mm:ss" type="datetime" :time.sync="yt.editObj.acceptanceTime"> </yi_time_input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/customer/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- kezhihuacaidan -->
      <template v-if="yt.editObj.action == 'kezhihuacaidan'">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini">
            <div>
              <span style="font-size: 2px; color: #989898;">{{ $t('qingzaixiafangxuanzecaidanyuanniu') }}</span>
            </div>
            <el-tabs v-model="current_tab">
              <!-- 搜索框 -->
              <el-form-item size="mini">
                <el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText"> </el-input>
              </el-form-item>
              <!-- <el-tab-pane label="Admin" name="first">
								<el-tree ref="treeAdmin" :data="menus[0]" show-checkbox node-key="id"
									:default-expand-all="false" :default-checked-keys="yt.editObj.menuIds">
								</el-tree>
							</el-tab-pane> -->
              <el-tab-pane label="Web" name="first">
                <el-tree ref="treeWeb" :data="menus[1]" show-checkbox node-key="id" :default-expand-all="false" :default-checked-keys="currentMenuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="App" name="second">
                <el-tree ref="treeApp" :data="menus[2]" show-checkbox node-key="id" :default-expand-all="false" :default-checked-keys="currentMenuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
              <el-tab-pane label="Pad" name="third">
                <el-tree ref="treePad" :data="menus[3]" show-checkbox node-key="id" :default-expand-all="false" :default-checked-keys="currentMenuIds" class="filter-tree" :filter-node-method="filterNode"> </el-tree>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
        <!--注意，el-dialog的slot不能写成#footer-->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" @click="yt.req('POST', '/web/system/auth/menu/custom/allot', beforeAddOrUpdate)" type="primary">{{ $t('baocun') }} </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'kehuleixingbiangeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item class="noborder" :label="$t('kehubianma')">
            <el-input disabled v-model="yt.editObj.code"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('kehumingcheng')">
            <el-input disabled v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jiukehuleixing')">
            <yi_dictionary_select disabled :type="'CUSTOMER_TYPE'" :ids.sync="yt.editObj.old_type"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('xinkehuleixing')" required>
            <yi_dictionary_select :type="'CUSTOMER_TYPE'" :ids.sync="yt.editObj.type"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="editCustomerType" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 模板点编辑弹窗 -->
      <template v-if="yt.editObj.action == 'shujuxieyimuban'">
        <div class="dialog-scroller">
          <template_list :customerId="yt.editObj.id"></template_list>
        </div>
      </template>
      <!-- 续期信息 -->
      <template v-if="yt.editObj.action === 'xuqixinxi'">
        <div class="dialog-scroller">
          <trenewal_list :customerInfo="yt.editObj"></trenewal_list>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import template_list from '@@/pages/admin/customer/info/protocol/list';
import template_point from '@@/pages/admin/customer/info/protocol/template_point';
import template_point_import from '@@/pages/admin/customer/info/protocol/point_import_excel';
import trenewal_list from '@@/pages/admin/customer/info/renewal/list'
export default {
  components: {
    template_list,
    template_point,
    template_point_import,
    trenewal_list
  },
  name: 'admin_customer_info_list',
  data() {
    return {
      filterText: '',
      current_tab: 'first',
      currentMenuIds: [],
      menus: [],
      columns: [
        {
          label: 'kehubianma',
          prop: 'code'
        },
        {
          label: 'kehumingcheng',
          prop: 'name'
        },
        {
          label: 'kehujiancheng',
          prop: 'shortName'
        },
        {
          label: 'kehuleixing',
          prop: 'type',
          type: 'dictionary',
          key: 'CUSTOMER_TYPE'
        },
        {
          label: 'shifouqiyong',
          prop: 'enable',
          type: 'bool',
          iln18: ['shi', 'fou']
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label: 'nianduyingshou',
          prop: 'annualRevenue',
          type: 'dictionary',
          key: 'CUSTOMER_INFO_ANNUAL_REVENUE'
        },
        {
          label: 'diyu',
          prop: 'region',
          type: 'dictionary',
          key: 'CUSTOMER_INFO_REGION'
        },
        {
          label: 'hangye',
          prop: 'industry',
          type: 'dictionary',
          key: 'CUSTOMER_INFO_INDUSTRY'
        },
        {
          label: 'jitaiguimo',
          prop: 'scale',
          type: 'dictionary',
          key: 'CUSTOMER_INFO_MACHINE_SCALE'
        },
        {
          label: 'kehudengji',
          prop: 'level',
          type: 'dictionary',
          key: 'CUSTOMER_INFO_LEVEL'
        },
        {
          label: 'xiangmuzongjian',
          prop: 'projectDirector'
        },
        {
          label: 'xiangmujingli',
          prop: 'projectManager'
        },
        {
          label: 'jishuzhichi',
          prop: 'technicalSupport'
        },
        {
          label:'shouqian',
          prop: 'presales'
        },
        {
          label: 'xiaoshou',
          prop:'sales'
        },
        {
          label:'shengshiqu',
          prop: 'cityAdcode',
          type: 'slot',
          width: 180
        },
        {
          label: 'banshichu',
          prop: 'offices'
        },
        {
          label: 'yewuyuan',
          prop:'salesman'
        },
        {
          label: 'jitaileixing',
          prop:'machineType',
          type: 'dictionary',
          key: 'CUSTOMER_INFO_MACHINE_TYPE'
        },
        {
          label: 'zhengcejiqudao',
          prop: 'policiesChannels'
        },
        {
          label:'shangjichuangjianshijian',
          prop: 'nicheCreateTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm:ss'
        },
        {
          label: 'shixiaoshijian',
          prop: 'endTime',
          type: 'time',
          format: 'YYYY-MM-DD'
        },
        {
          label:'yanshoushijian',
          prop: 'acceptanceTime',
          type: 'time',
          format: 'YYYY-MM-DD HH:mm:ss'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 230,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.SELECT_URL = '/web/customer/getCustomerByIds';
      this.yt.SELECT_RESULT_KEY = 'data';
      this.yt.SELECT_ID = 'id';
      this.yt.SELECT_TITLE = 'name';
      this.yt.get(1);
      this.getDictCatList();
      this.getAdminMenus();
    }, 300);
  },
  watch: {
    filterText(val) {
      // 树结构 - 根据关键字搜索
      this.$refs.treeWeb.filter(val);
      this.$refs.treeApp.filter(val);
      this.$refs.treePad.filter(val);
    }
  },
  methods: {
    // 关键字过滤方法
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    beforeAdd(params) {
      params.timeZone = 'Asia/Shanghai';
      return params;
    },
    beforeAddOrUpdate(params) {
      // params.menuIds = [...this.$refs.treeAdmin.getCheckedKeys(), ...this.$refs.treeWeb.getCheckedKeys(), ...this
      // 	.$refs.treeApp.getCheckedKeys(), ...this.$refs.treePad.getCheckedKeys()
      // ]
      params.customerId = params.id;
      params.menuIds = [...this.$refs.treeWeb.getCheckedKeys(), ...this.$refs.treeApp.getCheckedKeys(), ...this.$refs.treePad.getCheckedKeys()];
      return params;
    },
    async showKezhiDialog(customer) {
      let response = await this.http.get('/web/system/auth/menu/custom/getCustomerMenuByCustomerId', {
        params: {
          customerId: customer.id
        }
      });
      this.currentMenuIds = response.data;
      this.yt.showEditDialog('kezhihuacaidan', customer, 'w1');
    },

    getAdminMenus() {
      //先查询出所有平台的菜单
      this.menus = new Array(4);
      for (var i = 0; i < 4; i++) {
        (i => {
          this.http
            .get('web/system/auth/menu/custom/treeList', {
              params: {
                platform: i + 1
              }
            })
            .then(res => {
              this.menus[i] = res.data.rows.map(item => {
                //二级
                let children1;
                if (item.children) {
                  children1 = item.children.map(item2 => {
                    //三级
                    let children2;
                    if (item2.children) {
                      children2 = item2.children.map(item3 => {
                        const remark = item3.remark ? `(${item3.remark})` : '';
                        return {
                          label: this.$t(item3.code) + remark,
                          id: item3.id
                        };
                      });
                    }
                    const remark = item2.remark ? `(${item2.remark})` : '';
                    return {
                      label: this.$t(item2.code) + remark,
                      id: item2.id,
                      children: children2
                    };
                  });
                }

                const remark = item.remark ? `(${item.remark})` : '';
                return {
                  label: this.$t(item.code) + remark,
                  id: item.id,
                  children: children1
                };
              });
            });
        })(i);
      }
    },
    // 新增默认设置"是否启用"的值为启用
    setAddEnable() {
      this.yt.editObj.enable = true;
    },
    beforeShowLeiXingDialog(editObj) {
      editObj.old_type = editObj.type;
      return editObj;
    },
    async getDictCatList() {
      let response = await this.http.get('/web/config/dictType/page', {
        params: {
          pageNum: 1,
          pageSize: 10
        }
      });
      this.dictionaryList = response.data.rows;
    },
    editCustomerType() {
      this.yt.editObj.loading = true;
      let params = this.utils.copy(this.yt.editObj);
      this.http
        .post('/web/customer/editCustomerType', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get(1);
          this.yt.isShowEditDialog = false;
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
        })
        .finally(() => {
          this.yt.editObj.loading = false;
        });
    }
  }
};
</script>
